// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Ry8L","footer":"ModalCreateQualiphyProcedure_footer__WfXLy","additionData":"ModalCreateQualiphyProcedure_additionData__2p-2W"};